import React from "react";
import { applicationManifestState } from "../../../recoil/atoms";
import { useRecoilValue } from "recoil";
import { ApplicationManifest } from "../../../model/manifest/ApplicationManifest";
import { useParams } from "react-router-dom";
import { ITextProps, IStackItemStyles, Stack, Text } from "@fluentui/react";

export const CustomFormFooter: React.FC = () => {
    const applicationManifest: ApplicationManifest = useRecoilValue(applicationManifestState);
    var { formId } = useParams();

    const getFormFooter = (): string => {
        var form = applicationManifest.Pages.find(i => i.Id === formId);
        return form!.FooterText;
    }

    const stackItemStyles: IStackItemStyles = {
        root: {
            paddingTop: "15px",
            paddingBottom: "10px"
        }
    };

    return (
        <Stack.Item styles={stackItemStyles}>
            <Text variant={"xLarge" as ITextProps['variant']}>
                {getFormFooter()}
            </Text>
        </Stack.Item>
    );
}